export default "__VITE_ASSET__B28PuWwm__"